(() => {
  document.querySelectorAll('[data-click-open]').forEach((button) => {
    button.addEventListener('click', () => {
      button.classList.add('active');
      document.querySelectorAll(button.dataset.clickOpen).forEach((container) => {
        container.classList.add('is-open');
      });
    });
  });

  document.querySelectorAll('[data-click-close]').forEach((button) => {
    button.addEventListener('click', () => {
      const selector = button.dataset.clickClose;
      document.querySelectorAll(selector).forEach((container) => {
        container.classList.remove('is-open');
      });
      document.querySelectorAll(`[data-click-open="${selector}"]`).forEach((element) => {
        element.classList.remove('active');
      });
    });
  });
})();
